import {register} from '@shopify/theme-sections'
import '../../styles/sections/section-new-icon-6-col.scss'

export default register(`section-new-icon-6-col`, {
    onLoad() {

    },
    onUnload() {

    }
})